// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.nt-modal {
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 50px 20px;
}
@media only screen and (min-width: 768px) {
  .nt-modal {
    padding-left: 240px;
  }
}
.nt-modal__overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 0;
}
.nt-modal__card {
  position: relative;
  z-index: 1;
  width: min(500px, 100%);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
.nt-modal__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f1f1f2, #ececed);
  border-bottom: 1px solid #e7eaec;
}
.nt-modal__header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgb(105, 190, 40);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.nt-modal__header-icon--teal {
  background: rgb(0, 173, 208);
}
.nt-modal__title {
  font-size: 15px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
  line-height: 1.3;
}
.nt-modal__subtitle {
  font-size: 12px;
  color: #676a6c;
  margin: 2px 0 0;
  line-height: 1.3;
  opacity: 0.7;
}
.nt-modal__close {
  margin-left: auto;
  width: 30px;
  height: 30px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #ccc;
  transition: all 0.15s ease;
  flex-shrink: 0;
}
.nt-modal__close:hover {
  background: rgba(245, 67, 89, 0.06);
  color: rgb(245, 67, 89);
  border-color: rgba(245, 67, 89, 0.2);
}
.nt-modal__body {
  padding: 20px;
}
.nt-modal__footer {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 16px;
  margin-top: 4px;
}

.nt-tabs {
  display: flex;
  border-bottom: 1px solid #e7eaec;
  background: #fff;
}
.nt-tabs__btn {
  flex: 1;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #ccc;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.nt-tabs__btn i {
  font-size: 12px;
}
.nt-tabs__btn:hover {
  color: #676a6c;
  background: rgba(241, 241, 242, 0.5);
}
.nt-tabs__btn--active {
  color: rgb(105, 190, 40);
  border-bottom-color: rgb(105, 190, 40);
}
.nt-tabs__btn--active:hover {
  color: rgb(105, 190, 40);
  background: rgba(105, 190, 40, 0.03);
}

.nt-field {
  margin-bottom: 16px;
}
.nt-field:last-child {
  margin-bottom: 0;
}
.nt-field__label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
  margin-bottom: 6px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.nt-field__input {
  width: 100%;
  padding: 9px 12px;
  font-size: 13px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  background: #fff;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.nt-field__input::placeholder {
  color: #ccc;
}
.nt-field__input:focus {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
}
.nt-field__input--short {
  max-width: 140px;
}
.nt-field__hint {
  display: block;
  font-size: 11px;
  color: #676a6c;
  margin-top: 4px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.nt-field__row {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}
.nt-field__row .nt-field {
  flex: 1;
  margin-bottom: 0;
}

.nt-preview {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  margin-bottom: 16px;
  background: rgba(0, 173, 208, 0.08);
  border: 1px solid rgba(0, 173, 208, 0.2);
  border-left: 3px solid rgb(0, 173, 208);
  border-radius: 6px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.nt-preview__icon {
  color: rgb(0, 173, 208);
  font-size: 16px;
  flex-shrink: 0;
}
.nt-preview__text {
  font-size: 13px;
  color: #676a6c;
  line-height: 1.5;
}
.nt-preview__text strong {
  color: #6d6e71;
  font-weight: 700;
}

.nt-criteria {
  display: flex;
  flex-direction: column;
  gap: 0;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  overflow: hidden;
}
.nt-criteria__option {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  cursor: pointer;
  margin: 0;
  border-bottom: 1px solid #e7eaec;
  transition: background 0.1s ease;
}
.nt-criteria__option:last-child {
  border-bottom: none;
}
.nt-criteria__option:hover {
  background: rgba(0, 173, 208, 0.02);
}
.nt-criteria__option input[type=radio] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.nt-criteria__radio {
  width: 16px;
  height: 16px;
  border: 2px solid #e7eaec;
  border-radius: 50%;
  flex-shrink: 0;
  position: relative;
  margin-top: 2px;
  transition: all 0.15s ease;
}
input:checked + .nt-criteria__radio {
  border-color: rgb(105, 190, 40);
  background: rgb(105, 190, 40);
}
input:checked + .nt-criteria__radio::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fff;
}
.nt-criteria__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.nt-criteria__name {
  font-size: 13px;
  font-weight: 600;
  color: #676a6c;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.nt-criteria__desc {
  font-size: 11px;
  color: #ccc;
  line-height: 1.3;
}

.nt-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px 20px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}
.nt-btn i {
  font-size: 12px;
}
.nt-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
}
.nt-btn--primary:hover {
  background: #569c21;
}
.nt-btn--ghost {
  background: none;
  color: #ccc;
  padding: 9px 12px;
}
.nt-btn--ghost:hover {
  color: #676a6c;
}
.nt-btn--disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.nt-success {
  text-align: center;
  padding: 24px 0;
}
.nt-success__icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(105, 190, 40, 0.1);
  color: rgb(105, 190, 40);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin: 0 auto 12px;
}
.nt-success__title {
  font-size: 16px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0 0 4px;
}
.nt-success__text {
  font-size: 13px;
  color: #ccc;
  margin: 0;
}

.nt-form-flow {
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/dialogbox/update-teampopup/update-teampopup.component.scss","webpack://./src/app/components/dialogbox/teams-input-popup/teams-input-popup.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AC3YA;EACI,eAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;AD8YJ;AC5YI;EATJ;IAUQ,mBAAA;ED+YN;AACF;AC7YI;EACI,eAAA;EACA,QAAA;EACA,+BAAA;EACA,UAAA;AD+YR;AC5YI;EACI,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0EAAA;EACA,gBAAA;AD8YR;AC1YI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,qDAAA;EACA,gCAAA;AD4YR;ACzYI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BFxBQ;EEyBR,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AD2YR;ACzYQ;EACI,4BFnCI;AC8ahB;ACvYI;EACI,eAAA;EACA,gBAAA;EACA,cFvBa;EEwBb,wEFhEK;EEiEL,SAAA;EACA,gBAAA;ADyYR;ACtYI;EACI,eAAA;EACA,cFpCa;EEqCb,eAAA;EACA,gBAAA;EACA,YAAA;ADwYR;ACrYI;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WF/CY;EEgDZ,0BAAA;EACA,cAAA;ADuYR;ACrYQ;EACI,mCAAA;EACA,uBFvEM;EEwEN,oCAAA;ADuYZ;AClYI;EACI,aAAA;ADoYR;AChYI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;ADkYR;;AC5XA;EACI,aAAA;EACA,gCAAA;EACA,gBAAA;AD+XJ;AC7XI;EACI,OAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEF/HK;EEgIL,WFtFY;EEuFZ,gBAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AD+XR;AC7XQ;EAAI,eAAA;ADgYZ;AC9XQ;EACI,cF3GS;EE4GT,oCAAA;ADgYZ;AC7XQ;EACI,wBF5HI;EE6HJ,sCF7HI;AC4fhB;AC7XY;EACI,wBFhIA;EEiIA,oCAAA;AD+XhB;;ACvXA;EACI,mBAAA;AD0XJ;ACxXI;EAAe,gBAAA;AD2XnB;ACzXI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cFnIa;EEoIb,kBAAA;EACA,wEF7KK;ACwiBb;ACxXI;EACI,WAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,wEFtLK;EEuLL,cFpJa;EEqJb,gBAAA;EACA,aAAA;EACA,wDAAA;AD0XR;ACxXQ;EAAiB,WFlJL;AC6gBpB;ACzXQ;EACI,8BF1KI;EE2KJ,4CAAA;AD2XZ;ACxXQ;EACI,gBAAA;AD0XZ;ACtXI;EACI,cAAA;EACA,eAAA;EACA,cFxKa;EEyKb,eAAA;EACA,wEF7MK;ACqkBb;ACrXI;EACI,aAAA;EACA,SAAA;EACA,mBAAA;ADuXR;ACrXQ;EACI,OAAA;EACA,gBAAA;ADuXZ;;AChXA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,mCAAA;EACA,wCAAA;EACA,uCAAA;EACA,kBAAA;EACA,wEFxOS;AC2lBb;ACjXI;EACI,uBFtNQ;EEuNR,eAAA;EACA,cAAA;ADmXR;AChXI;EACI,eAAA;EACA,cF/Ma;EEgNb,gBAAA;ADkXR;AChXQ;EACI,cF9MS;EE+MT,gBAAA;ADkXZ;;AC3WA;EACI,aAAA;EACA,sBAAA;EACA,MAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AD8WJ;AC5WI;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,gCAAA;EACA,gCAAA;AD8WR;AC5WQ;EAAe,mBAAA;AD+WvB;AC9WQ;EAAU,mCAAA;ADiXlB;AC/WQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;ADiXZ;AC7WI;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;AD+WR;AC7WQ;EACI,+BF/QI;EEgRJ,6BFhRI;AC+nBhB;AC7WY;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AD+WhB;AC1WI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AD4WR;ACzWI;EACI,eAAA;EACA,gBAAA;EACA,cF7Ra;EE8Rb,wEFjUK;AC4qBb;ACxWI;EACI,eAAA;EACA,WF5RY;EE6RZ,gBAAA;AD0WR;;ACpWA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEFrVS;EEsVT,YAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;ADuWJ;ACrWI;EAAI,eAAA;ADwWR;ACtWI;EACI,6BFxUQ;EEyUR,WAAA;ADwWR;ACvWQ;EAAU,mBAAA;AD0WlB;ACvWI;EACI,gBAAA;EACA,WF5TY;EE6TZ,iBAAA;ADyWR;ACxWQ;EAAU,cFrUG;ACgrBrB;ACxWI;EACI,YAAA;EACA,mBAAA;EACA,oBAAA;AD0WR;;ACpWA;EACI,kBAAA;EACA,eAAA;ADuWJ;ACrWI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,wBFtWQ;EEuWR,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;ADuWR;ACpWI;EACI,eAAA;EACA,gBAAA;EACA,cFhWa;EEiWb,wEFzYK;EE0YL,eAAA;ADsWR;ACnWI;EACI,eAAA;EACA,WFrWY;EEsWZ,SAAA;ADqWR;;AChWA;EACI,aAAA;EACA,sBAAA;ADmWJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","img {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n.fn-body h1,\n.fn-body h2,\n.fn-body h3,\n.fn-body h4,\n.fn-body h5,\n.fn-body h6 {\n  --hGap: 10px;\n  font-family: \"Museo-700\";\n  color: #6d6e71;\n  margin-bottom: var(--hGap);\n  margin-top: 0;\n}\n.fn-body h1:last-child,\n.fn-body h2:last-child,\n.fn-body h3:last-child,\n.fn-body h4:last-child,\n.fn-body h5:last-child,\n.fn-body h6:last-child {\n  margin-bottom: 0;\n}\n.fn-body h1,\n.fn-body .h1-text {\n  font-size: 44px;\n  line-height: 1.1;\n}\n@media only screen and (max-width: 767px) {\n  .fn-body h1,\n  .fn-body .h1-text {\n    font-size: 38px;\n  }\n}\n.fn-body h2,\n.fn-body .h2-text {\n  font-size: 38px;\n  line-height: 1.2;\n}\n@media only screen and (max-width: 767px) {\n  .fn-body h2,\n  .fn-body .h2-text {\n    font-size: 32px;\n  }\n}\n.fn-body h3,\n.fn-body .h3-text {\n  font-size: 32px;\n  line-height: 1.2;\n}\n@media only screen and (max-width: 767px) {\n  .fn-body h3,\n  .fn-body .h3-text {\n    font-size: 24px;\n  }\n}\n.fn-body h4,\n.fn-body .h4-text {\n  font-size: 24px;\n  line-height: 1.2;\n}\n.fn-body h5,\n.fn-body .h5-text {\n  font-size: 18px;\n  line-height: 1.2;\n}\n.fn-body h6,\n.fn-body .h6-text {\n  font-size: 16px;\n  line-height: 1.3;\n}\n.fn-body p {\n  font-size: 18px;\n  line-height: 1.6;\n  color: #6a6a6a;\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n.fn-body p:last-child {\n  margin-bottom: 0;\n}\n@media only screen and (max-width: 767px) {\n  .fn-body p {\n    font-size: 16px;\n  }\n}\n.fn-body ul,\n.fn-body ol {\n  padding: 0;\n  margin: 0;\n}\n.fn-body sup {\n  font-size: 0.7em;\n  position: relative;\n  top: 5px;\n  display: inline-block;\n  vertical-align: top;\n}\n\n.bg-grey {\n  background-color: #eee;\n}\n\n.fn-container {\n  max-width: 1080px;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n}\n@media only screen and (min-width: 992px) {\n  .fn-container {\n    margin-left: 0;\n  }\n}\n.fn-container--fluid {\n  max-width: 1200px;\n}\n.fn-container--small {\n  max-width: 820px;\n  width: 100%;\n}\n\n.text-center {\n  text-align: center;\n}\n.text-right {\n  text-align: right;\n}\n\n.d-none {\n  display: none;\n}\n\n.section-title {\n  text-align: center;\n}\n.section-title:not(:last-child) {\n  margin-bottom: 40px;\n}\n.section-title h2:not(:last-child) {\n  margin-block-end: 20px;\n}\n.section-title p {\n  max-width: 900px;\n  width: 100%;\n  margin-inline: auto;\n  font-size: 22px;\n}\n.section-title p:not(:last-child) {\n  margin-block-end: 20px;\n}\n@media only screen and (max-width: 767px) {\n  .section-title p {\n    font-size: 18px;\n  }\n}\n.section-title .section-title__linkcontainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n.section-title .section-title__linkcontainer:not(:last-child) {\n  margin-block-end: 20px;\n}\n.section-title .section-title__linkcontainer > * {\n  margin: 5px;\n}\n.section-title .section-title__linkcontainer .fn-btn {\n  padding-block: 6px;\n  padding-inline: 13px;\n  font-size: 12px;\n  font-family: \"MuseoSans-300\";\n}\n\n.section-padding {\n  padding-block: 60px;\n}\n@media only screen and (max-width: 767px) {\n  .section-padding {\n    padding-block: 40px;\n  }\n}\n.section-padding-small {\n  padding-block: 30px;\n}\n.section-padding-all {\n  padding: 60px;\n}\n@media only screen and (max-width: 767px) {\n  .section-padding-all {\n    padding: 30px;\n  }\n}\n.section-padding-all-small {\n  padding: 30px;\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n}\n.headline--small-border {\n  --lineSize: 6px;\n}\n.headline:not(:last-child) {\n  margin-bottom: calc(var(--hGap) * 2.5);\n}\n.headline::before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: var(--lineSize);\n  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);\n}\n\n.custom-list li {\n  font-size: 18px;\n  line-height: 1.4;\n  color: #6a6a6a;\n  list-style: none;\n  position: relative;\n  padding-left: 15px;\n}\n.custom-list li:not(:last-child) {\n  margin-bottom: 4px;\n}\n.custom-list li::before {\n  content: \"\";\n  position: absolute;\n  top: 10px;\n  left: 0;\n  width: 3px;\n  height: 3px;\n  background-color: var(--clrProfile);\n}\n\n.color-clarify {\n  --clrProfile: rgb(0, 173, 208);\n}\n\n.color-ideate {\n  --clrProfile: rgb(255, 121, 0);\n}\n\n.color-develop {\n  --clrProfile: rgb(105, 190, 40);\n}\n\n.color-implement {\n  --clrProfile: rgb(245, 67, 89);\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: rgb(105, 190, 40);\n  color: #fff;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: \"Museo-700\";\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n}\n.fn-btn:focus {\n  outline: 1px dashed #6a6a6a;\n  outline-offset: 4px;\n}\n.fn-btn:hover {\n  background-color: #6d6e71;\n  color: #fff;\n}\n.fn-btn--sm {\n  font-size: 14px;\n  padding-block: 10px;\n  padding-inline: 20px;\n}\n.fn-btn--grey {\n  background-color: #f1f1f2;\n  color: #6d6e71;\n}\n.fn-btn--ongoing {\n  background-color: #f8ac59;\n  color: #fff;\n}\n.fn-btn--ongoing i {\n  animation: spin 0.3s infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.color-clarify {\n  --clrProfile: rgb(0, 173, 208);\n}\n\n.color-ideate {\n  --clrProfile: rgb(255, 121, 0);\n}\n\n.color-develop {\n  --clrProfile: rgb(105, 190, 40);\n}\n\n.color-implement {\n  --clrProfile: rgb(245, 67, 89);\n}\n\n.w-4 {\n  width: 33.3333333333%;\n}\n\n.w-3 {\n  width: 25%;\n}\n.w-3--wd {\n  width: 33.3333333333%;\n}\n\n.w-6 {\n  width: 50%;\n}\n\n.fn-row {\n  --rGap: 15px;\n  --rGap-minus: calc(-1 * var(--rGap));\n  display: flex;\n  flex-wrap: wrap;\n  margin-inline: var(--rGap-minus);\n}\n.fn-row--col-gap-exist .fn-col {\n  margin-bottom: 30px;\n}\n.fn-col {\n  padding-inline: var(--rGap);\n}\n.fn-justify-center {\n  justify-content: center;\n}\n.fn-items-center {\n  align-items: center;\n}\n\n.mx-auto {\n  margin-inline: auto;\n}\n.ml-auto {\n  margin-inline-start: auto;\n}\n.ml-0 {\n  margin-inline-start: 0;\n}\n.mr-auto {\n  margin-inline-end: auto;\n}\n.mr-0 {\n  margin-inline-end: 0;\n}\n\n.nt-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 100000;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 50px 20px;\n}\n@media only screen and (min-width: 768px) {\n  .nt-modal {\n    padding-left: 240px;\n  }\n}\n.nt-modal__overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  z-index: 0;\n}\n.nt-modal__card {\n  position: relative;\n  z-index: 1;\n  width: min(500px, 100%);\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);\n  overflow: hidden;\n}\n.nt-modal__header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  background: linear-gradient(135deg, #f1f1f2, #ececed);\n  border-bottom: 1px solid #e7eaec;\n}\n.nt-modal__header-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: rgb(105, 190, 40);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n.nt-modal__header-icon--teal {\n  background: rgb(0, 173, 208);\n}\n.nt-modal__title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #6d6e71;\n  font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  margin: 0;\n  line-height: 1.3;\n}\n.nt-modal__subtitle {\n  font-size: 12px;\n  color: #676a6c;\n  margin: 2px 0 0;\n  line-height: 1.3;\n  opacity: 0.7;\n}\n.nt-modal__close {\n  margin-left: auto;\n  width: 30px;\n  height: 30px;\n  border: 1px solid #e7eaec;\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  color: #ccc;\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n}\n.nt-modal__close:hover {\n  background: rgba(245, 67, 89, 0.06);\n  color: rgb(245, 67, 89);\n  border-color: rgba(245, 67, 89, 0.2);\n}\n.nt-modal__body {\n  padding: 20px;\n}\n.nt-modal__footer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-top: 16px;\n  margin-top: 4px;\n}\n\n.nt-tabs {\n  display: flex;\n  border-bottom: 1px solid #e7eaec;\n  background: #fff;\n}\n.nt-tabs__btn {\n  flex: 1;\n  padding: 10px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  color: #ccc;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n.nt-tabs__btn i {\n  font-size: 12px;\n}\n.nt-tabs__btn:hover {\n  color: #676a6c;\n  background: rgba(241, 241, 242, 0.5);\n}\n.nt-tabs__btn--active {\n  color: rgb(105, 190, 40);\n  border-bottom-color: rgb(105, 190, 40);\n}\n.nt-tabs__btn--active:hover {\n  color: rgb(105, 190, 40);\n  background: rgba(105, 190, 40, 0.03);\n}\n\n.nt-field {\n  margin-bottom: 16px;\n}\n.nt-field:last-child {\n  margin-bottom: 0;\n}\n.nt-field__label {\n  display: block;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #6d6e71;\n  margin-bottom: 6px;\n  font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n.nt-field__input {\n  width: 100%;\n  padding: 9px 12px;\n  font-size: 13px;\n  border: 1px solid #e7eaec;\n  border-radius: 6px;\n  font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  color: #676a6c;\n  background: #fff;\n  outline: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n.nt-field__input::placeholder {\n  color: #ccc;\n}\n.nt-field__input:focus {\n  border-color: rgb(0, 173, 208);\n  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);\n}\n.nt-field__input--short {\n  max-width: 140px;\n}\n.nt-field__hint {\n  display: block;\n  font-size: 11px;\n  color: #676a6c;\n  margin-top: 4px;\n  font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n.nt-field__row {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n.nt-field__row .nt-field {\n  flex: 1;\n  margin-bottom: 0;\n}\n\n.nt-preview {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  margin-bottom: 16px;\n  background: rgba(0, 173, 208, 0.08);\n  border: 1px solid rgba(0, 173, 208, 0.2);\n  border-left: 3px solid rgb(0, 173, 208);\n  border-radius: 6px;\n  font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n.nt-preview__icon {\n  color: rgb(0, 173, 208);\n  font-size: 16px;\n  flex-shrink: 0;\n}\n.nt-preview__text {\n  font-size: 13px;\n  color: #676a6c;\n  line-height: 1.5;\n}\n.nt-preview__text strong {\n  color: #6d6e71;\n  font-weight: 700;\n}\n\n.nt-criteria {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  border: 1px solid #e7eaec;\n  border-radius: 8px;\n  overflow: hidden;\n}\n.nt-criteria__option {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px 14px;\n  cursor: pointer;\n  margin: 0;\n  border-bottom: 1px solid #e7eaec;\n  transition: background 0.1s ease;\n}\n.nt-criteria__option:last-child {\n  border-bottom: none;\n}\n.nt-criteria__option:hover {\n  background: rgba(0, 173, 208, 0.02);\n}\n.nt-criteria__option input[type=radio] {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.nt-criteria__radio {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #e7eaec;\n  border-radius: 50%;\n  flex-shrink: 0;\n  position: relative;\n  margin-top: 2px;\n  transition: all 0.15s ease;\n}\ninput:checked + .nt-criteria__radio {\n  border-color: rgb(105, 190, 40);\n  background: rgb(105, 190, 40);\n}\ninput:checked + .nt-criteria__radio::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #fff;\n}\n.nt-criteria__text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.nt-criteria__name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #676a6c;\n  font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n.nt-criteria__desc {\n  font-size: 11px;\n  color: #ccc;\n  line-height: 1.3;\n}\n\n.nt-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 9px 20px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n}\n.nt-btn i {\n  font-size: 12px;\n}\n.nt-btn--primary {\n  background: rgb(105, 190, 40);\n  color: #fff;\n}\n.nt-btn--primary:hover {\n  background: #569c21;\n}\n.nt-btn--ghost {\n  background: none;\n  color: #ccc;\n  padding: 9px 12px;\n}\n.nt-btn--ghost:hover {\n  color: #676a6c;\n}\n.nt-btn--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.nt-success {\n  text-align: center;\n  padding: 24px 0;\n}\n.nt-success__icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: rgba(105, 190, 40, 0.1);\n  color: rgb(105, 190, 40);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  margin: 0 auto 12px;\n}\n.nt-success__title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #6d6e71;\n  font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  margin: 0 0 4px;\n}\n.nt-success__text {\n  font-size: 13px;\n  color: #ccc;\n  margin: 0;\n}\n\n.nt-form-flow {\n  display: flex;\n  flex-direction: column;\n}","@import './../../../../assets/styles/variables';\n\n// ── New Team / Add Member / Session Modal ──\n\n.nt-modal {\n    position: fixed;\n    inset: 0;\n    z-index: 100000;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    padding: 50px 20px;\n\n    @media #{$mobile-up} {\n        padding-left: 240px;\n    }\n\n    &__overlay {\n        position: fixed;\n        inset: 0;\n        background: rgba(0, 0, 0, 0.45);\n        z-index: 0;\n    }\n\n    &__card {\n        position: relative;\n        z-index: 1;\n        width: min(500px, 100%);\n        background: #fff;\n        border-radius: 12px;\n        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);\n        overflow: hidden;\n    }\n\n    // ── Header ──\n    &__header {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        padding: 16px 20px;\n        background: linear-gradient(135deg, $color-neutral-light, darken($color-neutral-light, 2%));\n        border-bottom: 1px solid $color-grey-1;\n    }\n\n    &__header-icon {\n        width: 36px;\n        height: 36px;\n        border-radius: 8px;\n        background: $develop-color;\n        color: #fff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n        flex-shrink: 0;\n\n        &--teal {\n            background: $clarify-color;\n        }\n    }\n\n    &__title {\n        font-size: 15px;\n        font-weight: 700;\n        color: $color-neutral-dark;\n        font-family: $font-stack;\n        margin: 0;\n        line-height: 1.3;\n    }\n\n    &__subtitle {\n        font-size: 12px;\n        color: $body-content-color;\n        margin: 2px 0 0;\n        line-height: 1.3;\n        opacity: 0.7;\n    }\n\n    &__close {\n        margin-left: auto;\n        width: 30px;\n        height: 30px;\n        border: 1px solid $color-grey-1;\n        border-radius: 6px;\n        background: #fff;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 13px;\n        color: $color-neutral-mid;\n        transition: all 0.15s ease;\n        flex-shrink: 0;\n\n        &:hover {\n            background: rgba($implement-color, 0.06);\n            color: $implement-color;\n            border-color: rgba($implement-color, 0.2);\n        }\n    }\n\n    // ── Body ──\n    &__body {\n        padding: 20px;\n    }\n\n    // ── Footer ──\n    &__footer {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        padding-top: 16px;\n        margin-top: 4px;\n    }\n}\n\n// ── Tabs ──\n\n.nt-tabs {\n    display: flex;\n    border-bottom: 1px solid $color-grey-1;\n    background: #fff;\n\n    &__btn {\n        flex: 1;\n        padding: 10px 16px;\n        font-size: 13px;\n        font-weight: 600;\n        font-family: $font-stack;\n        color: $color-neutral-mid;\n        background: none;\n        border: none;\n        border-bottom: 2px solid transparent;\n        cursor: pointer;\n        transition: all 0.15s ease;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 6px;\n\n        i { font-size: 12px; }\n\n        &:hover {\n            color: $body-content-color;\n            background: rgba($color-neutral-light, 0.5);\n        }\n\n        &--active {\n            color: $develop-color;\n            border-bottom-color: $develop-color;\n\n            &:hover {\n                color: $develop-color;\n                background: rgba($develop-color, 0.03);\n            }\n        }\n    }\n}\n\n// ── Form Fields ──\n\n.nt-field {\n    margin-bottom: 16px;\n\n    &:last-child { margin-bottom: 0; }\n\n    &__label {\n        display: block;\n        font-size: 12px;\n        font-weight: 700;\n        text-transform: uppercase;\n        letter-spacing: 0.04em;\n        color: $color-neutral-dark;\n        margin-bottom: 6px;\n        font-family: $font-stack;\n    }\n\n    &__input {\n        width: 100%;\n        padding: 9px 12px;\n        font-size: 13px;\n        border: 1px solid $color-grey-1;\n        border-radius: 6px;\n        font-family: $font-stack;\n        color: $body-content-color;\n        background: #fff;\n        outline: none;\n        transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n        &::placeholder { color: $color-neutral-mid; }\n\n        &:focus {\n            border-color: $clarify-color;\n            box-shadow: 0 0 0 3px rgba($clarify-color, 0.1);\n        }\n\n        &--short {\n            max-width: 140px;\n        }\n    }\n\n    &__hint {\n        display: block;\n        font-size: 11px;\n        color: $body-content-color;\n        margin-top: 4px;\n        font-family: $font-stack;\n    }\n\n    &__row {\n        display: flex;\n        gap: 12px;\n        margin-bottom: 16px;\n\n        .nt-field {\n            flex: 1;\n            margin-bottom: 0;\n        }\n    }\n}\n\n// ── Live Preview Banner ──\n\n.nt-preview {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 14px;\n    margin-bottom: 16px;\n    background: rgba($clarify-color, 0.08);\n    border: 1px solid rgba($clarify-color, 0.2);\n    border-left: 3px solid $clarify-color;\n    border-radius: 6px;\n    font-family: $font-stack;\n\n    &__icon {\n        color: $clarify-color;\n        font-size: 16px;\n        flex-shrink: 0;\n    }\n\n    &__text {\n        font-size: 13px;\n        color: $body-content-color;\n        line-height: 1.5;\n\n        strong {\n            color: $color-neutral-dark;\n            font-weight: 700;\n        }\n    }\n}\n\n// ── Criteria Options ──\n\n.nt-criteria {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    border: 1px solid $color-grey-1;\n    border-radius: 8px;\n    overflow: hidden;\n\n    &__option {\n        display: flex;\n        align-items: flex-start;\n        gap: 10px;\n        padding: 12px 14px;\n        cursor: pointer;\n        margin: 0;\n        border-bottom: 1px solid $color-grey-1;\n        transition: background 0.1s ease;\n\n        &:last-child { border-bottom: none; }\n        &:hover { background: rgba($clarify-color, 0.02); }\n\n        input[type=\"radio\"] {\n            position: absolute;\n            opacity: 0;\n            width: 0;\n            height: 0;\n        }\n    }\n\n    &__radio {\n        width: 16px;\n        height: 16px;\n        border: 2px solid $color-grey-1;\n        border-radius: 50%;\n        flex-shrink: 0;\n        position: relative;\n        margin-top: 2px;\n        transition: all 0.15s ease;\n\n        input:checked + & {\n            border-color: $develop-color;\n            background: $develop-color;\n\n            &::after {\n                content: '';\n                position: absolute;\n                top: 50%;\n                left: 50%;\n                transform: translate(-50%, -50%);\n                width: 6px;\n                height: 6px;\n                border-radius: 50%;\n                background: #fff;\n            }\n        }\n    }\n\n    &__text {\n        display: flex;\n        flex-direction: column;\n        gap: 2px;\n    }\n\n    &__name {\n        font-size: 13px;\n        font-weight: 600;\n        color: $body-content-color;\n        font-family: $font-stack;\n    }\n\n    &__desc {\n        font-size: 11px;\n        color: $color-neutral-mid;\n        line-height: 1.3;\n    }\n}\n\n// ── Buttons ──\n\n.nt-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 9px 20px;\n    font-size: 13px;\n    font-weight: 600;\n    font-family: $font-stack;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    white-space: nowrap;\n\n    i { font-size: 12px; }\n\n    &--primary {\n        background: $develop-color;\n        color: #fff;\n        &:hover { background: darken($develop-color, 8%); }\n    }\n\n    &--ghost {\n        background: none;\n        color: $color-neutral-mid;\n        padding: 9px 12px;\n        &:hover { color: $body-content-color; }\n    }\n\n    &--disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n        pointer-events: none;\n    }\n}\n\n// ── Success State ──\n\n.nt-success {\n    text-align: center;\n    padding: 24px 0;\n\n    &__icon {\n        width: 48px;\n        height: 48px;\n        border-radius: 50%;\n        background: rgba($develop-color, 0.1);\n        color: $develop-color;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 20px;\n        margin: 0 auto 12px;\n    }\n\n    &__title {\n        font-size: 16px;\n        font-weight: 700;\n        color: $color-neutral-dark;\n        font-family: $font-stack;\n        margin: 0 0 4px;\n    }\n\n    &__text {\n        font-size: 13px;\n        color: $color-neutral-mid;\n        margin: 0;\n    }\n}\n\n// ── Flow helper ──\n.nt-form-flow {\n    display: flex;\n    flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
